import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import * as api from 'app/api';
import produce from 'immer';
import set from 'lodash/set';

const CHANGE = 'escrow/contracts/CHANGE';
export const change = createAction(CHANGE);

const CHANGE_BENEFITS = 'escrow/contracts/CHANGE_BENEFITS';
export const changeBenefits = createAction(CHANGE_BENEFITS);

const CHANGE_ATTACHMENT = 'escrow/contracts/CHANGE_ATTACHMENT';
export const changeAttachment = createAction(CHANGE_ATTACHMENT);

const GET_CONTRACT_FORM = 'escrow/contracts/GET_CONTRACT_FORM';
export const getContractForm = createAction(GET_CONTRACT_FORM, api.getEscrowContractForm);

const POST_CONTRACT_FORM = 'escrow/contracts/POST_CONTRACT_FORM';
export const postContractForm = createAction(POST_CONTRACT_FORM, api.postEscrowContractForm);

const initialState = {
	photoBlobs: {
		evidencePhoto1: '',
		evidencePhoto2: '',
		evidencePhoto3: '',
		evidencePhoto4: '',
		evidencePhoto5: '',
	},
	confirmStatus: '',
	attachments: [],
};

export default handleActions(
	{
		[CHANGE]: (state, action) =>
			produce(state, (draft) => {
				const { schema, name, value } = action.payload;
				set(draft, [...schema, name], value);
			}),
		[CHANGE_BENEFITS]: (state, action) =>
			produce(state, (draft) => {
				const value = action.payload;
				const current = draft.param.nominees[0].benefits;
				const idx = current.findIndex((item) => item === value);
				let sum;
				if (idx >= 0) {
					current.splice(idx, 1);
					sum = current;
				}
				if (idx < 0) sum = current.concat(value);
				set(draft, ['param', 'nominees', '0', 'benefits'], sum);
			}),
		[CHANGE_ATTACHMENT]: (state, action) =>
			produce(state, (draft) => {
				const { type, key, name, targetName } = action.payload;
				const current = draft.attachments;
				const idx = current.findIndex((item) => item.targetName === targetName);
				const nextItem = {
					targetName,
					attachmentType: type,
					attachment: {
						key,
						name,
					},
				};
				let sum;
				if (idx >= 0) {
					current.splice(idx, 1);
					sum = current;
				}
				if (idx < 0) sum = current.concat(nextItem);
				set(draft, 'attachments', sum);
			}),
		...pender({
			type: GET_CONTRACT_FORM,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const nominees = data.nominees.map((item) => {
						const benefits = item.benefits ? [...item.benefits] : [];
						return {
							...item,
							residentNo: '',
							certifiedZipCd: '',
							certifiedAddress: '',
							postalZipCd: '',
							postalAddress: '',
							benefits,
						};
					});
					set(draft, 'param', { ...data, nominees });
				}),
		}),
	},
	initialState,
);
